import { Link } from "react-router-dom";

export default function Logo() {
  return (
    <Link to="/" data-testid="logo-link" className="group flex items-center gap-2.5">
      <span className="grid h-9 w-9 place-items-center rounded-xl bg-gradient-to-br from-sky-400 to-indigo-500 shadow-[0_0_24px_rgba(56,189,248,0.35)] transition-shadow duration-300 group-hover:shadow-[0_0_32px_rgba(56,189,248,0.55)]">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M9 8.5 15 9M8.5 9.5 10 14.5M15.5 11.5 13 15" stroke="white" strokeWidth="1.1" opacity="0.75" />
          <circle cx="7" cy="7" r="2.3" fill="white" />
          <circle cx="17" cy="9" r="2.3" fill="white" opacity="0.85" />
          <circle cx="11" cy="17" r="2.3" fill="white" opacity="0.65" />
        </svg>
      </span>
      <span className="font-display text-xl font-bold tracking-tight text-white">
        Talent<span className="text-sky-400">ify</span>
      </span>
    </Link>
  );
}
